import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="navbar">
      <div className="navbar-inner container">
        <Link to="/" className="navbar-logo" onClick={() => setOpen(false)}>
          AK
        </Link>
        <button
          type="button"
          className="navbar-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
        >
          <span className={open ? 'open' : ''} />
          <span className={open ? 'open' : ''} />
          <span className={open ? 'open' : ''} />
        </button>
        <nav className={`navbar-nav ${open ? 'open' : ''}`}>
          <Link
            to="/"
            className={isActive('/') ? 'active' : ''}
            onClick={() => setOpen(false)}
          >
            About
          </Link>
          <Link
            to="/experience"
            className={isActive('/experience') ? 'active' : ''}
            onClick={() => setOpen(false)}
          >
            Experience
          </Link>
          <Link
            to="/writing"
            className={isActive('/writing') ? 'active' : ''}
            onClick={() => setOpen(false)}
          >
            Writing
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
